/**
 * Beatui Context Base Event Types
 * ===============================
 * Author: Vicco Wang
 * Date: 2019/04/23
 * ================================
 * License: MIT
 * ================================
 *
 */
export default {
  mouseenter: 'mouseenter',
  mouseleave: 'mouseleave',
  click: 'click',
  contextmenu: 'contextmenu'
}
